/* eslint-disable react-hooks/exhaustive-deps */
import { Check, ChevronsUpDown } from "lucide-react";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

import { useEffect, useMemo, useState } from "react";
import { GenericType } from "@/types";
export const ExpressionSelect2 = ({
  placeholder,
  value,
  onChange,
  defaultValue,
  options,
  bindValue,
  bindLabel,
  className,
  onBlur,
}: GenericType) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      if (defaultValue) {
        onChange(defaultValue);
      }
    }, 100);
  }, [defaultValue]);

  // const displayLabel = useMemo(() => {
  //   return options?.find(
  //     (item: GenericType) => item?.[bindValue]?.trim() == value?.trim()
  //   )?.[bindLabel];
  // }, [options, defaultValue]);

  const displayLabel = useMemo(() => {
    return options?.find(
      (item: GenericType) =>
        String(item?.[bindValue] ?? "").trim() === String(value ?? "").trim()
    )?.[bindLabel];
  }, [options, value]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className={cn("w-full justify-between capitalize", className)}
        >
          <span className="truncate">
            {displayLabel || <span className="opacity-65">{placeholder}</span>}
          </span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>

      <PopoverContent
        className="w-full p-0  z-[9999]"
        align="start"
        onBlur={onBlur}
      >
        <Command>
          <CommandInput placeholder="Search..." className="h-9" />
          <CommandList>
            <CommandEmpty>No Item found.</CommandEmpty>
            <CommandGroup>
              {options?.map((option: GenericType, index: number) => (
                <CommandItem
                  key={index}
                  value={option?.[bindLabel]}
                  onSelect={() => {
                    onChange(option?.[bindValue]);
                    setOpen(false);
                  }}
                >
                  {option?.[bindLabel]}
                  <Check
                    className={cn(
                      "ml-auto",
                      String(value)?.toLowerCase() ===
                        String(option?.[bindValue])?.toLowerCase()
                        ? "opacity-100"
                        : "opacity-0"
                    )}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
